// Builds a WhatsApp click-to-chat link with a pre-filled ("auto") message.
export const waUrl = (number, text) =>
  `https://wa.me/${(number || "").replace(/\D/g, "")}?text=${encodeURIComponent(text || CONTACT_TEXT)}`;

// Generic "Contact us" greeting shown across the site.
export const CONTACT_TEXT = "Hi Smart Logistics! I'd like to get in touch with your team.";

// Tracking greeting + package details.
export const trackText = ({ trackingNumber, name, phone, country }) =>
`Hi Smart Logistics!
I'd like to track my package.
Tracking / Package no.: ${trackingNumber || "-"}
Name: ${name || "-"}
Phone: ${phone || "-"}
Country: ${country || "-"}

Please share the latest status of my package. Thank you!`;
